(function () {
  var STORAGE_KEY = 'be_push_prompt_v1';
  var DELAY_MS = 4500;
  var RESHOW_DAYS = 14;

  function readState() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeState(patch) {
    try {
      var next = Object.assign({}, readState(), patch);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
      /* ignore */
    }
  }

  function shouldShowPrompt() {
    if (!('Notification' in window)) return false;

    var permission = Notification.permission;
    if (permission === 'granted' || permission === 'denied') return false;

    var state = readState();
    if (state.dismissedForever) return false;

    if (state.dismissedAt) {
      var elapsed = Date.now() - state.dismissedAt;
      if (elapsed < RESHOW_DAYS * 24 * 60 * 60 * 1000) return false;
    }

    return true;
  }

  function openPrompt(root) {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
  }

  function closePrompt(root) {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      root.hidden = true;
    }, 260);
  }

  function initPushPrompt() {
    var root = document.querySelector('[data-be-push-prompt]');
    if (!root || !shouldShowPrompt()) return;

    var acceptBtn = root.querySelector('[data-be-push-accept]');
    var laterBtn = root.querySelector('[data-be-push-later]');
    var dismissBtn = root.querySelector('[data-be-push-dismiss]');

    window.setTimeout(function () {
      if (shouldShowPrompt()) openPrompt(root);
    }, DELAY_MS);

    function dismissTemporary() {
      writeState({ dismissedAt: Date.now() });
      closePrompt(root);
    }

    function dismissForever() {
      writeState({ dismissedForever: true, dismissedAt: Date.now() });
      closePrompt(root);
    }

    acceptBtn &&
      acceptBtn.addEventListener('click', function () {
        Notification.requestPermission()
          .then(function (result) {
            writeState({
              permission: result,
              grantedAt: result === 'granted' ? Date.now() : null,
              dismissedForever: result !== 'default',
              dismissedAt: Date.now(),
            });
            closePrompt(root);
          })
          .catch(function () {
            dismissTemporary();
          });
      });

    laterBtn && laterBtn.addEventListener('click', dismissTemporary);
    dismissBtn && dismissBtn.addEventListener('click', dismissTemporary);

    root.addEventListener('click', function (event) {
      if (event.target === root) dismissTemporary();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPushPrompt);
  } else {
    initPushPrompt();
  }
})();
